module.exports = __webpack_public_path__ + "static/media/trans-Payment.635365ed.svg";